import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import PropTypes from "prop-types";
import {
  administrationEmployee,
  administrationEmployeeEditProfile,
  administrationEmployees,
  administrationLocations,
  administrationPositions,
  administrationPosition,
  administrationGroups,
  administrationGroup,
  administrationSpecialAssignments,
  manageSpecialAssignment,
  administrationBulkAssignmentTool,
  administrationLocation,
  administrationGroupInfo
} from "../../routes/AdminRoutes";
import { adminConsoleRoot } from "../../routes/Routes";
import {
  Employees,
  Locations,
  Positions,
  Groups,
  SpecialAssignments,
  BulkAssignmentTool
} from "../../views";
import EmployeeContainer from "../../views/Employees/EmployeeContainer";
import EmployeeContainerEditProfile from "../../views/Employees/EmployeeContainerEditProfile";
import ManageSpecialAssignmentContainer from "../../views/SpecialAssignments/ManageSpecialAssignmentContainer";
import { useSelector } from "react-redux";
import AdminLocation from "./AdminLocation";
import AdminPosition from "./AdminPosition";
import AdminGroup from "./AdminGroup";

const AdminAdministration = () => {
  const adminExperience = useSelector(
    state => state.userState.user.permissions.allowAdminExperience
  );

  if (!adminExperience) {
    return <Redirect to={adminConsoleRoot} />;
  }

  return (
    <>
      <Switch>
        <Route
          exact
          path={administrationEmployeeEditProfile}
          component={EmployeeContainerEditProfile}
        />
        <Route path={administrationEmployee} component={EmployeeContainer} />
      </Switch>
      <Route exact path={administrationEmployees} component={Employees} />
      <Route path={administrationGroups} component={Groups} exact />
      <Route
        path={[administrationGroup, administrationGroupInfo]}
        component={AdminGroup}
      />
      <Route path={administrationLocations} component={Locations} exact />
      <Route path={administrationLocation} component={AdminLocation} />
      <Route path={administrationPositions} component={Positions} exact />
      <Route path={administrationPosition} component={AdminPosition} />
      <Route
        exact
        path={administrationSpecialAssignments}
        component={SpecialAssignments}
      />
      <Route
        path={manageSpecialAssignment}
        component={ManageSpecialAssignmentContainer}
      />
      <Route
        exact
        path={administrationBulkAssignmentTool}
        component={BulkAssignmentTool}
      />
    </>
  );
};

AdminAdministration.propTypes = {
  match: PropTypes.any
};

export default AdminAdministration;
